import { billsSlice } from '../store/slice';

export const { setBills, setUpcomingBill } = billsSlice.actions;
